// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import NotAuthorized from './not-authorized';

// Containers
import withPermissions from '../../containers/with-permissions';

// Contexts
import {PanelContext} from '../../contexts/panel-context';
import {RouteContext} from '../../contexts/route-context';

class Permissions extends Component {
    componentWillMount() {
        const {hidePanel} = this.context;
        const {hidePanel: hidePanelProp, isAuthorized} = this.props;

        if (hidePanelProp && !isAuthorized()) {
            hidePanel();
        }
    }

    renderNotAuthorizedMessage = (notAuthorizedMessage) => (
        <NotAuthorized>
            {notAuthorizedMessage === true ? 'Access is not granted for this section' : notAuthorizedMessage}
        </NotAuthorized>
    );

    autoRedirect = (autoRedirect) => (
        <RouteContext.Consumer>
            {({push}) => {
                push(autoRedirect === true ? '/' : autoRedirect);

                return null;
            }}
        </RouteContext.Consumer>
    );

    render() {
        const {autoRedirect, children = <span />, isAuthorized, notAuthorizedMessage} = this.props;

        return isAuthorized()
            ? children
            : autoRedirect
              ? this.autoRedirect(autoRedirect)
              : notAuthorizedMessage
                ? this.renderNotAuthorizedMessage(notAuthorizedMessage)
                : null;
    }
}

Permissions.propTypes = {
    autoRedirect: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    hidePanel: PropTypes.bool,
    isAuthorized: PropTypes.func.isRequired,
    notAuthorizedMessage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

Permissions.contextType = PanelContext;

export default withPermissions(Permissions);
